module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/media-inquiry/MEDIAINQUIRY_02-ecoconscious.png";